import { useEffect, useState } from "react";
import Link from "next/link";
import LookCard from "./LookCard";
import ArrowRow from "./ArrowRow";
import SpinWheelCard from "./SpinWheel";
import { getProgress } from "../lib/fashionProgress";
import styles from "../../styles/FashionLibrary.module.css";

// Glamzy Lookbook on the home page: the spin wheel, this week's new looks, then a pick from every world, as the
// library's own cards. A card opens its look's page; the visitor's styled looks show their green tick.
// looks: small card objects from homeLooks() (src/lib/fashionLibrary.js), via the page's getStaticProps.
export default function FashionHomeRow({ looks, newSlugs = [] }) {
  const [progress, setProgress] = useState(null); // read in the browser after mount
  useEffect(() => { setProgress(getProgress()); }, []);
  if (!looks || !looks.length) return null;

  return (
    <ArrowRow className={styles.homeRow} title="Glamzy Lookbook" extra={(
      <>
        <span className={styles.arrowNote}>New looks every Monday · style one theme at a time</span>
        <Link href="/glamzy" className={styles.continueBtn}>See all looks</Link>
      </>
    )}>
      <SpinWheelCard />
      {looks.map((l) => (
        <LookCard key={l.slug} look={l} big badge={newSlugs.includes(l.slug) ? "New" : null}
          stars={progress && progress.styled[l.slug]} />
      ))}
    </ArrowRow>
  );
}
